import React, { useState, useEffect, useRef, useCallback } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import LandingPage from "./components/LandingPage";
import AboutPage from "./components/AboutPage";
import ContactPage from "./components/ContactPage";
import SoftwarePage from "./components/SoftwarePage";
import AIPage from "./components/AIPage";
import DigitalPage from "./components/DigitalPage";
import CloudPage from "./components/CloudPage";
import ITPage from "./components/ITPage";
import DesignPage from "./components/DesignPage";
import TransformationPage from "./components/TransformationPage";
import PortfolioPage from "./components/PortfolioPage";
import ContactUsPage from "./components/ContactUsPage";

const ROUTE_MAP = {
  home: "/",
  about: "/about-us",
  solutions: "/technology-solutions",
  contact: "/contact-us",
  software: "/services/custom-software-development",
  ai: "/services/artificial-intelligence-solutions",
  digital: "/services/digital-strategy-consulting",
  cloud: "/services/cloud",
  it: "/services/managed-it-services",
  design: "/services/ui-ux-product-design",
  transformation: "/services/digital-business-transformation",
  portfolio: "/case-studies",
};

function getPageFromPath(pathname) {
  for (const [page, path] of Object.entries(ROUTE_MAP)) {
    if (path === pathname) return page;
  }
  return "home";
}

export default function App() {
  const nav = useNavigate();
  const location = useLocation();
  const [fade, setFade] = useState(true);
  const navTimer = useRef(null);
  const isNavigating = useRef(false);

  const currentPage = getPageFromPath(location.pathname);

  const navigate = useCallback((page) => {
    if (isNavigating.current) return;
    const path = ROUTE_MAP[page] || "/";
    if (path === location.pathname) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    isNavigating.current = true;
    setFade(false);
    if (navTimer.current) clearTimeout(navTimer.current);
    navTimer.current = setTimeout(() => {
      nav(path);
      window.scrollTo({ top: 0, behavior: "smooth" });
      setFade(true);
      isNavigating.current = false;
    }, 300);
  }, [nav, location.pathname]);

  useEffect(() => {
    setFade(true);
  }, [location.pathname]);

  return (
    <div className="app">
      <Navbar currentPage={currentPage} onNavigate={navigate} />
      <main className={`page-transition ${fade ? "page-visible" : "page-hidden"}`}>
        <Routes>
          <Route path="/" element={<LandingPage onNavigate={navigate} />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/technology-solutions" element={<ContactPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/services/custom-software-development" element={<SoftwarePage onNavigate={navigate} />} />
          <Route path="/services/artificial-intelligence-solutions" element={<AIPage onNavigate={navigate} />} />
          <Route path="/services/digital-strategy-consulting" element={<DigitalPage onNavigate={navigate} />} />
          <Route path="/services/cloud" element={<CloudPage onNavigate={navigate} />} />
          <Route path="/services/managed-it-services" element={<ITPage onNavigate={navigate} />} />
          <Route path="/services/ui-ux-product-design" element={<DesignPage onNavigate={navigate} />} />
          <Route path="/services/digital-business-transformation" element={<TransformationPage onNavigate={navigate} />} />
          <Route path="/case-studies" element={<PortfolioPage />} />
          <Route path="*" element={<LandingPage onNavigate={navigate} />} />
        </Routes>
      </main>
      <Footer onNavigate={navigate} />
    </div>
  );
}
